import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { useNavigate } from "react-router";

import styles from "./fab.module.scss";

export function Fab() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={styles.fab}
      onClick={() => navigate("/habits/new")}
      data-testid="create-habit-fab"
      aria-label="Create new habit"
    >
      <PlusIcon size={24} aria-hidden="true" />
    </button>
  );
}
